import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try {
    var info = gen[key](arg);
    var value = info.value;
}
catch (error) {
    reject(error);
    return;
} if (info.done) {
    resolve(value);
}
else {
    Promise.resolve(value).then(_next, _throw);
} }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
import React from "react";
/*
 * The reason we use Global State instead of Component State is that
 * when the user clicks something on the main page and then clicks back,
 * we don't want to reset the user's scroll position. If we don't maintain
 * state, then we will "lose" some of the items when the user clicks
 * back and the state resets, which obviously resets scroll position as well.
 */
export var GlobalStateContext = /*#__PURE__*/ React.createContext({
    // Which page infinite scroll should fetch next.
    cursor: 0,
    // Toggle between pagination and inf. scroll for this demo & fallback in case of error.
    useInfiniteScroll: true,
    isInitializing: function isInitializing() {
        return true;
    },
    updateState: function updateState() { },
    hasMore: function hasMore() {
        return false;
    },
    loadMore: function loadMore() { },
    toggle: function toggle() { }
});
export var GlobalState = /*#__PURE__*/ function (_React$Component) {
    _inheritsLoose(GlobalState, _React$Component);
    function GlobalState(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // console.log("*** Constructing Global State ***");
        // State also contains metadata for items, e.g. state["page81"] (only contains keys for _received_ metadata)
        _this.isInitializing = function () {
            return _this.state.cursor === 0;
        };
        _this.updateState = function (mergeableStateObject) {
            _this.setState(mergeableStateObject);
        };
        _this.loadMore = /*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee() {
            var pageNum, _this$setState, res, pageImages;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            // console.log("Fetching metadata for page " + this.state.cursor);
                            pageNum = _this.state.cursor;
                            _this.setState(function (state) {
                                return {
                                    cursor: state.cursor + 1
                                };
                            }); // TODO: make sure this is guaranteed to set state before another loadMore may be able to fire!
                            _context.prev = 2;
                            _context.next = 5;
                            return fetch(__PATH_PREFIX__ + "/gallery_pages/index" + pageNum + ".json");
                        case 5:
                            res = _context.sent;
                            _context.next = 8;
                            return res.json();
                        case 8:
                            pageImages = _context.sent;
                            _this.setState((_this$setState = {}, _this$setState["page" + pageNum] = pageImages, _this$setState));
                            _context.next = 15;
                            break;
                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context["catch"](2);
                            _this.setState({
                                useInfiniteScroll: false // Fallback to Pagination on error.
                            });
                        case 15:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, null, [[2, 12]]);
        }));
        _this.hasMore = function (pageContext) {
            if (!_this.state.useInfiniteScroll)
                return false;
            if (_this.isInitializing())
                return true;
            return _this.state.cursor <= pageContext.countPages;
        };
        _this.state = {
            cursor: 0,
            useInfiniteScroll: true,
            isInitializing: _this.isInitializing,
            updateState: _this.updateState,
            hasMore: _this.hasMore,
            loadMore: _this.loadMore,
            toggle: _this.toggle
        };
        return _this;
    }
    var _proto = GlobalState.prototype;
    // This exists to demo toggling. You will not need this in production.
    _proto.toggle = function toggle(useInfiniteScroll, pageContext) {
        if (useInfiniteScroll) {
            // Toggle back to infinite scroll, adjust scroll position. Otherwise we might load 1000s of items at once.
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            window.scrollTo(0, scrollTop - 1);
            this.setState({
                useInfiniteScroll: true
            });
        }
        else {
            // Toggle back to pagination, reset items and cursor.
            var state = {};
            for (var i = this.state.cursor - 1; i >= 0; i--) {
                state["page" + i] = undefined;
            }
            state["page" + pageContext.currentPage] = pageContext.pageImages;
            state["cursor"] = pageContext.currentPage + 1;
            state["useInfiniteScroll"] = false;
            this.setState(state);
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ React.createElement(GlobalStateContext.Provider, {
            value: this.state
        }, this.props.children);
    };
    return GlobalState;
}(React.Component);
